import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group alignC" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode(_component_el_form, {
      ref: "formRef",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "优惠券名称" }, {
          default: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.form.title), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "有效期" }, {
          default: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.form.start_time_text) + " - " + _toDisplayString(_ctx.form.end_time_text), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "优惠类型" }, {
          default: _withCtx(() => [
            (_ctx.form.type == 1)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("span", null, "满" + _toDisplayString(_ctx.form.full_price) + "元 减" + _toDisplayString(_ctx.form.reduce_price) + "元", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.type == 2)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("span", null, "无门槛 减" + _toDisplayString(_ctx.form.reduce_price) + "元", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "使用范围" }, {
          default: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.form.is_use == 0 ? '全部' : '单个服务'), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_directive_loading, _ctx.form_load]
    ])
  ]))
}